import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createVehiclesFailed, createVehiclesSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_MDS_URL } from '../../../configs';

export default function* createVehicles(action) {
  try {
    const url = `${BACKEND_MDS_URL}/agency/vehicles/`;
    const pool = action.payload;
    const response = yield makeRequest(url, pool, action, 'POST', true, {
      Accept: 'application/json;version=1.2.0',
    });
    if (response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createVehiclesSuccessful());
      yield call(resolveActionPromise(action, data?.data || data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createVehiclesFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createVehiclesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
